import * as React from 'react';
import * as _ from 'lodash';
import { css, StyleSheet } from 'aphrodite';
import { BlIcon } from '@blend/shared-react';
import { colors, combineStyles, fonts } from '@blend/consumer-components';
import { generateInnerHtml } from '@blend/shared-react';
import { POSSIBLE_ERROR_MESSAGES } from 'login-utils/loginErrorMessageUtils';
import { notificationTextStyle } from '../styles';

const styles = StyleSheet.create({
  error: combineStyles(notificationTextStyle, {
    ...fonts.Gotham,
    fontWeight: fonts.weight.book,
    alignItems: 'center',
    display: 'flex',
    color: colors.brickMinus4,
    outline: 'none',
  }),
  iconWrapper: {
    marginRight: 5,
  },
});

const ErrorMessage = ({ errorText, errorId, ...htmlProps }: { errorText: string; errorId?: string }) => {
  // Only allow HTML for predefined error messages.
  if (!_.includes(POSSIBLE_ERROR_MESSAGES, errorText)) {
    errorText = _.escape(errorText);
  }

  const errorProp = errorId ? { id: errorId } : {};

  return (
    <span className={css(styles.error)} {...errorProp} tabIndex={-1} {...htmlProps}>
      <span className={css(styles.iconWrapper)}>
        <BlIcon icon="error-2" />
      </span>
      <span data-it="Error-text" {...generateInnerHtml(errorText)} />
    </span>
  );
};

export default ErrorMessage;
